import {
  ActiveRecord,
  ActiveRecords,
  BaseElementWidget,
  DslDefinitionType,
  RuntimeFunctionDefinition,
  SPI,
  TableWidget,
  Widget,
  RowContext
} from '@kunlun/dependencies';
import { VxeTableDefines } from 'vxe-table';
import { Optional } from '@kunlun/shared';
import { toString } from 'lodash-es';

@SPI.ClassFactory(
  BaseElementWidget.Token({
    widget: 'table',
    model: 'deli.aries.seller.DeliAriesSellerShipBillLog',
    viewName: '品牌分销工作台-记账流水-人工还款_TABLE_uiView679aa8ff7df346168d82898984c76098'
  })
)
export class SettlementRepayTableWidget extends TableWidget {

  public initialize(props) {
    if (props.template) {
      props.template?.widgets?.forEach((a) => {
        if (a.dslNodeType === DslDefinitionType.FIELD && this.statisticsFieldList.includes(a.name)) {
          a.statistics = true;
        }
      });
    }
    super.initialize(props);
    return this;
  }

  // 需要表尾做合并的字段名称
  public statisticsFieldList = ['currentRepaymentAmount'];

  @Widget.Reactive()
  protected get showFooter(): boolean | undefined {
    return true;
  }

  @Widget.Method()
  public onCheckedChange(data: ActiveRecords) {
    super.onCheckedChange(data)

    this.getTableInstance()?.getOrigin().updateFooter()
  }

  @Widget.Method()
  public onCheckedAllChange(selected: boolean, data: ActiveRecord[]) {
    super.onCheckedAllChange(selected, data)
    this.getTableInstance()?.getOrigin().updateFooter()
  }

  //选中行才统计金额
  protected generatorStatisticsRow(columns: VxeTableDefines.ColumnInfo[], data: ActiveRecord[]): string[] {
    return super.generatorStatisticsRow(columns, this.activeRecords || [])
  }

  //行内编辑不做更新
  protected async executeRowEditorUpdate(functionDefinition: RuntimeFunctionDefinition, data: ActiveRecord) {
    return data;
  }

  //FIXME 强制清理
  protected async rowEditorClosedAfterProcess(context: RowContext): Promise<void> {
    super.rowEditorClosedAfterProcess(context);
    this.lastedCurrentEditorContext = undefined;
  }

  @Widget.Reactive()
  protected get statisticsLabel(): string {
    return Optional.ofNullable(this.getDsl().statisticsLabel).map(toString).orElse('合计');
  }

}
